import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1 12H9V8h2v8zm4 0h-2V8h2v8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 8h2v8h-2zM9 8h2v8H9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
})), 'PauseCircleFilledTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PauseCircleFilledTwoTone.js
// module id = 5221
// module chunks = 2